import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-003f2cc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex cos-both-form-item" }

import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { listByParamCodes } from '@/api/common'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import {
  newClientEvaluationCreate, newClientEvaluationDraft,
  newClientEvaluationEdit
} from '@/api/overseasSales/newClientEvaluation'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  reviewHistory: {
    type: Array
  },
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  resetValue: {
    type: [Object, Array]
  }
},
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const props = __props
const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'ofbu_new_client_evaluation_add_btn' }
    : { edit: 'ofbu_new_client_evaluation_submit_review_btn', save: 'ofbu_new_client_evaluation_submit_review_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const queryNewClientId = computed(() => route.query.newClientId as unknown as number)
// 是否是再次提交审核 只要等于1 就是
const review = computed(() => route.query.review as string)
// 是否是转潜客 为1则是转潜客 无需审核且不能保存草稿
const toPotential = computed(() => route.query.toPotential as string)
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_invalid_reason: [], // 无效原因
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_area_code: [], // 手机区号
  ofbu_service_demand: [], // 服务需求
  ofbu_important: [], // 潜在收入
  ofbu_client_type: [], // 客户类型
  ofbu_business_type: [], // 客户业务类型
  ofbu_demand_info: [], // 需求海外仓
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 产品货型
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_shipments: [], // 发货量（月）
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [] // 服务主体（服务公司）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_invalid_reason',
      'ofbu_marketing_activity',
      'ofbu_area_code',
      'ofbu_service_demand',
      'ofbu_important',
      'ofbu_client_type',
      'ofbu_business_type',
      'ofbu_demand_info',
      'ofbu_inbound_package_type',
      'ofbu_sale_platform',
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('clue.当前审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: t('common.pleaseSelect') }],
  input: [{ required: true, message: t('common.pleaseInput') }],
  customerName: [{ required: true, message: t('common.pleaseInput') }],
  customerWebsite: [{ required: true, message: t('common.pleaseInput') }],
  clientType: [{ required: true, message: t('common.pleaseSelect') }],
  salesChannel: [{ required: true, message: t('common.pleaseSelect') }],
  businessTypeSelect: [{ required: true, message: t('common.pleaseSelect') }],
  servicesStandard: [{ required: true, message: t('common.pleaseSelect') }],
  salePlatform: [{ required: true, message: t('common.pleaseSelect') }],
  shipments: [{ required: true, message: t('common.pleaseSelect') }],
  salesCategory: [{ required: true, message: t('common.pleaseSelect') }],
  cargoType: [{ required: true, message: t('common.pleaseSelect') }],
  orderTypeDistribution: [{ required: true, message: t('common.pleaseInput') }],
  productValue: [{ required: true, message: t('common.pleaseInput') }],
  orderDistribution: [{ required: true, message: t('common.pleaseInput') }],
  skuType: [{ required: true, message: t('common.pleaseInput') }],
  skuUnit: [{ required: true, message: t('common.pleaseSelect') }],
  serviceType: [{ required: true, message: t('common.pleaseSelect') }],
  regionalWarehouse: [{ required: true, message: t('common.pleaseSelect') }],
  inboundPackageType: [{ required: true, message: t('common.pleaseSelect') }],
  averageInventoryVolume: [{ required: true, message: t('common.pleaseInput') }],
  firstInboundTime: [{ required: true, message: t('common.pleaseSelect') }],
  futureIncrement: [{ required: true, message: t('common.pleaseInput') }],
  systemIntegration: [{ required: true, message: t('common.pleaseInput') }],
  quotationType: [{ required: true, message: t('common.pleaseSelect') }]
}
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)
const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const loading = ref(false)
// 点击暂存
const handleSaveToDraft = () => {
  if (!dataForm.customerName) {
    DcMessage.error(t('tips.customerEnterTips'))
    formRef.value?.validate('customerName')
    return
  }
  formRef.value?.validate('customerName').then(() => {
    DcConfirm.warning({
      cancelText: t('btn.cancel'),
      content: t('tips.saveOaDraft', {
        oaTypeStr: t('common.新客评审')
      }),
      okText: t('btn.sure'),
      onOk() {
        saveDraft()
      }
    })
  })
}
// 保存草稿
const saveDraft = async () => {
  loading.value = true
  const params = cloneDeep(dataForm)
  try {
    if (params.business.businessTypeSelect) {
      params.business.businessType = [params.business.businessTypeSelect]
      params.business.businessTypeSelect = undefined
    }
    params.skipReview = false
    // 1/2, 新客评审/客户激活
    params.applyType = 1
    const data = await newClientEvaluationDraft(params, { custom: { errorMsg: false } })
    if (data.code === 200) {
      message.success(t('tips.saveSuccess'))
      goBack()
    } else {
      message.error(data.message)
    }
  } catch (error) {}
  loading.value = false
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const params = cloneDeep(dataForm)
    try {
      if (params.business.businessTypeSelect) {
        params.business.businessType = [params.business.businessTypeSelect]
        params.business.businessTypeSelect = undefined
      }
      // 这里判断是否再次提交评审id传进来，如果是空的那么一定是新增或者是草稿的详情
      if (queryNewClientId.value) {
        const data = await newClientEvaluationEdit(params)
        if (data.code === 200) {
          message.success(t('tips.activitySuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      } else {
        params.skipReview = toPotential.value === '1'
        // 1/2, 新客评审/客户激活
        params.applyType = 1
        const data = await newClientEvaluationCreate(params, { custom: { errorMsg: false } })
        if (data.code === 200) {
          message.success(t('tips.addSuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      }
    } catch (error) {
    }
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      rules: formRules,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('common.baseTitle'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "customerName",
              label: _unref(t)('clue.customerName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerName) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "customerWebsite",
              label: _unref(t)('clue.officialWeb')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerWebsite,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.customerWebsite) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (props.type !== 'view')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('clue.estAveRevenue'),
                        name: ['business', 'annualSales'],
                        rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.business.annualSales,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.business.annualSales) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "annualSalesUnit",
                        style: {"width":"30%"},
                        name: ['business', 'annualSalesUnit'],
                        class: "hide-label",
                        rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.ofbu_currency,
                            value: dataForm.business.annualSalesUnit,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.business.annualSalesUnit) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: _unref(t)('clue.estAveRevenue'),
                  name: ['business', 'annualSalesUnit'],
                  rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.ofbu_currency,
                      value: dataForm.business.annualSalesUnit,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.business.annualSalesUnit) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            (dataForm.applyNo)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  name: "applyNo",
                  label: _unref(t)('clue.申请单号'),
                  rules: { required: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.applyNo,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.applyNo) = $event)),
                      valueModifiers: { trim: true },
                      disabled: "",
                      view: props.type === 'view'
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.clientType'),
              name: "clientType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.ofbu_client_type,
                  value: dataForm.clientType,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.clientType) = $event)),
                  view: props.type === 'view'
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.salesChannel'),
              name: ['business', 'salesChannel'],
              rules: formRules.salesChannel
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.ofbu_sales_channel,
                  value: dataForm.business.salesChannel,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.business.salesChannel) = $event)),
                  view: props.type === 'view'
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('clue.业务需求'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.业务类型'),
              name: ['business', 'businessTypeSelect'],
              rules: formRules.businessTypeSelect
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.businessTypeSelect,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.business.businessTypeSelect) = $event)),
                  options: paramCodeData.ofbu_business_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.服务标准'),
              name: ['business',  'servicesStandard'],
              rules: formRules.servicesStandard
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.servicesStandard,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.business.servicesStandard) = $event)),
                  options: paramCodeData.ofbu_services_standard,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.销售平台'),
              name: ['business', 'salePlatform']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salePlatform,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.business.salePlatform) = $event)),
                  options: paramCodeData.ofbu_sale_platform,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.发货量(月)'),
              name: ['business',  'shipments'],
              rules: formRules.shipments
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.shipments,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.business.shipments) = $event)),
                  options: paramCodeData.ofbu_shipments,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.产品分类'),
              name: ['business', 'salesCategory'],
              rules: formRules.salesCategory
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salesCategory,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.business.salesCategory) = $event)),
                  options: paramCodeData.ofbu_sales_category,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.产品尺寸'),
              name: ['business', 'cargoType'],
              rules: formRules.cargoType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.cargoType,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.business.cargoType) = $event)),
                  options: paramCodeData.ofbu_product_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderTypeDistribution'],
              label: _unref(t)('clue.订单类型分布'),
              rules: formRules.orderTypeDistribution
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.订单类型分布输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('clue.订单类型分布')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.orderTypeDistribution,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.business.orderTypeDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.订单类型分布输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'productValue'],
              label: _unref(t)('clue.热销品价值(USD)'),
              rules: formRules.productValue
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.productValue,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.business.productValue) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderDistribution'],
              label: _unref(t)('clue.单品多品订单比例'),
              rules: formRules.orderDistribution
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.单品多品订单比例输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('clue.单品多品订单比例')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.orderDistribution,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.business.orderDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.单品多品订单比例输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'skuType'],
              label: _unref(t)('clue.SKU种类'),
              rules: formRules.skuType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.skuType,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.business.skuType) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.SKU单位'),
              name: ['business', 'skuUnit'],
              rules: formRules.skuUnit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.skuUnit,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.business.skuUnit) = $event)),
                  options: paramCodeData.ofbu_sku_unit,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.尾程服务需求'),
              name: ['business', 'serviceType'],
              rules: formRules.serviceType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.serviceType,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.business.serviceType) = $event)),
                  options: paramCodeData.ofbu_service_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.区域仓'),
              name: ['business', 'regionalWarehouse'],
              rules: formRules.regionalWarehouse
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.regionalWarehouse,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.business.regionalWarehouse) = $event)),
                  options: paramCodeData.ofbu_demand_info,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.入库包装方式'),
              name: ['business', 'inboundPackageType'],
              rules: formRules.inboundPackageType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.inboundPackageType,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.business.inboundPackageType) = $event)),
                  options: paramCodeData.ofbu_inbound_package_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'averageInventoryVolume'],
              label: _unref(t)('clue.平均在库体积'),
              rules: formRules.averageInventoryVolume
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.averageInventoryVolume,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.business.averageInventoryVolume) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'firstInboundTime'],
              label: _unref(t)('clue.预计第一次来货时间'),
              rules: formRules.firstInboundTime
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  isOutputBeijingTime: "",
                  startTime: dataForm.business.firstInboundTime,
                  "onUpdate:startTime": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.business.firstInboundTime) = $event)),
                  isRange: false,
                  view: props.type === 'view'
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'futureIncrement'],
              label: _unref(t)('clue.未来增量(月订单)'),
              rules: formRules.futureIncrement
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.futureIncrement,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.business.futureIncrement) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'systemIntegration'],
              label: _unref(t)('clue.系统对接需求')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.systemIntegration,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((dataForm.business.systemIntegration) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.系统对接需求输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.其他附件'),
              name: "otherFile",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: props.type === 'view',
                  value: dataForm.business.otherFile,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((dataForm.business.otherFile) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('clue.报价'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.价格类型'),
              name: ['business', 'quotationInfo', 'quotationType'],
              rules: formRules.quotationType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.quotationInfo.quotationType,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((dataForm.business.quotationInfo.quotationType) = $event)),
                  options: paramCodeData.ofbu_quotation_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (dataForm.business.quotationInfo.quotationType === 3469)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'quotationInfo', 'priceDocuments'],
                  label: _unref(t)('clue.报价策略'),
                  rules: { required: dataForm.business.quotationInfo.quotationType === 3469, message: _unref(t)('common.pleaseInput') }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.quotationInfo.priceDocuments,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((dataForm.business.quotationInfo.priceDocuments) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.客户报价/竞对报价'),
              name: ['business', 'quotationInfo', 'competitorPriceDocuments'],
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: props.type === 'view',
                  value: dataForm.business.quotationInfo.competitorPriceDocuments,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((dataForm.business.quotationInfo.competitorPriceDocuments) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              name: "remark",
              label: _unref(t)('common.remark'),
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        (props.type === 'view')
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: _unref(t)('clue.审核记录'),
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(CosTable, {
                  columns: reviewHistoryColumns.value,
                  style: {"padding":"0 6px 6px 6px"},
                  needPage: false,
                  "data-source": props.reviewHistory,
                  serial: "",
                  rowKey: "nodeId",
                  tableId: "newClientEvaluationReviewHistory",
                  dynamicColumnSetting: false
                }, null, 8, ["columns", "data-source"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (props.isEdit)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: dataForm,
          "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((dataForm) = $event)),
          formRef: formRef.value,
          resetValue: __props.resetValue,
          loading: loading.value,
          disabled: !props.isEdit
        }, {
          default: _withCtx(() => [
            (review.value !== '1' && toPotential.value!=='1')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: handleSaveToDraft,
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('btn.saveOaDraft')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSubmit,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.save&Submit')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["value", "formRef", "resetValue", "loading", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})